import { handleActions } from 'redux-actions';

import { pickPayload } from 'app/reducers/helpers';
import { SERIES_FETCHED } from 'app/features/series/actionTypes';

const initialState = [];

const series = handleActions({ [SERIES_FETCHED]: pickPayload }, initialState);

export default series;
